import { render } from "./MyRatingStats.vue?vue&type=template&id=3bc414a8&ts=true"
import script from "./MyRatingStats.vue?vue&type=script&lang=ts"
export * from "./MyRatingStats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__